import { Link } from "react-router-dom";
import { SpadeMark } from "@/components/brand";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#D4AF37]/15 bg-[#060608]">
      <div className="mx-auto max-w-7xl px-5 sm:px-8 py-16">
        <div className="grid gap-12 md:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-3">
              <SpadeMark className="h-8 w-8" />
              <span className="font-bebas text-3xl tracking-[0.22em] text-[#F6F4EE]">
                FINATEX<span className="text-[#D4AF37]">'26</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-[#A19E95]">
              The intercollegiate Commerce, Finance &amp; Accountancy festival of the Department of Commerce,
              CHRIST (Deemed to be University), Pune Lavasa. Strategy is the only house edge.
            </p>
            <p className="mt-6 font-mono text-xs text-[#B39343] tracking-[0.2em]">ALL BETS ON YOU ♠</p>
          </div>
          <div>
            <p className="eyebrow mb-5">Explore</p>
            <div className="flex flex-col gap-3 text-sm text-[#A19E95]">
              <Link to="/about" data-testid="footer-link-about" className="hover:text-[#D4AF37] transition-colors">The Festival</Link>
              <Link to="/events" data-testid="footer-link-events" className="hover:text-[#D4AF37] transition-colors">Events Arena</Link>
              <Link to="/schedule" data-testid="footer-link-schedule" className="hover:text-[#D4AF37] transition-colors">Schedule</Link>
              <Link to="/gallery" data-testid="footer-link-gallery" className="hover:text-[#D4AF37] transition-colors">Gallery</Link>
              <Link to="/register" data-testid="footer-link-register" className="hover:text-[#D4AF37] transition-colors">Register</Link>
            </div>
          </div>
          <div>
            <p className="eyebrow mb-5">The House</p>
            <div className="flex flex-col gap-3 text-sm text-[#A19E95]">
              <span>CHRIST (Deemed to be University)</span>
              <span>Pune Lavasa Campus, Maharashtra</span>
              <a href="mailto:finatex.lavasa@christuniversity.in" data-testid="footer-email" className="hover:text-[#D4AF37] transition-colors">
                finatex.lavasa@christuniversity.in
              </a>
              <span className="font-mono text-xs text-[#6E6B63]">20–21 NOVEMBER 2026</span>
            </div>
          </div>
        </div>
        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/5 pt-8">
          <p className="text-xs text-[#6E6B63]">© 2026 FINATEX, Department of Commerce. All rights reserved.</p>
          <Link to="/admin/login" data-testid="footer-link-admin" className="text-xs text-[#6E6B63] hover:text-[#D4AF37] transition-colors tracking-[0.2em] uppercase">
            Organiser Access
          </Link>
        </div>
      </div>
    </footer>
  );
}
